"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectionalSource = void 0;
var DirectionalSource;
(function (DirectionalSource) {
    DirectionalSource[DirectionalSource["Dpad"] = 0] = "Dpad";
    DirectionalSource[DirectionalSource["LeftStick"] = 1] = "LeftStick";
    DirectionalSource[DirectionalSource["ArrowKey"] = 2] = "ArrowKey";
})(DirectionalSource || (exports.DirectionalSource = DirectionalSource = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlyZWN0aW9uYWxTb3VyY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMvZGlyZWN0aW9uYWxTb3VyY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELElBQVksaUJBSVg7QUFKRCxXQUFZLGlCQUFpQjtJQUN6Qix5REFBSSxDQUFBO0lBQ0osbUVBQVMsQ0FBQTtJQUNULGlFQUFRLENBQUE7QUFDWixDQUFDLEVBSlcsaUJBQWlCLGlDQUFqQixpQkFBaUIsUUFJNUIifQ==